import { forwardRef, ReactNode } from 'react';
export const InputButton = forwardRef(({ children, onClick }: { children: ReactNode; onClick?: any }, ref) => (
  <button type="button" className="btn btn-sm btn-outline-primary mb-0" onClick={onClick} ref={ref as any}>
    {children}
  </button>
));
